import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { version } from 'config';

const Footer = () => (
  <footer className="footer">
    <Row className="justify-content-between text-center fs-10 mt-4 mb-3">
      <Col sm="auto">
        <p className="mb-0 text-600">
          All rights reserved {' '}
          <span className="d-none d-sm-inline-block">| </span>
          <br className="d-sm-none" /> {new Date().getFullYear()} &copy;{' '}
          <strong >Absolute Algorithms LLP</strong>
        </p>
      </Col>
      <Col sm="auto">
        <p className="mb-0 text-600">The content generated by this website is for educational purpose only</p>
      </Col>
    </Row>
  </footer>
);

export default Footer;
